const NotificationLogType = {
  ADDRESS: "ADDRESS",
  SPECIALTY: "SPECIALTY",
  FIELD_ACTIVITY: "FIELD_ACTIVITY",
  CONFIRMED_INFORMATION: "CONFIRMED_INFORMATION",
  CLOSED_SCREEN: "CLOSED_SCREEN",
};

export default NotificationLogType;
